/** Set B /ldproductnow motivation option keys. */
export const SET_B_LD_MOTIVATION_KEYS = [
  'taste',
  'brandImage',
  'productQuality',
  'price',
  'productFeatures',
  'recommendedByOthers',
  'mentholFlavorExperience',
] as const;

export type SetBLdMotivationKey = (typeof SET_B_LD_MOTIVATION_KEYS)[number];

export const SET_B_LD_MOTIVATION_LABELS: Record<SetBLdMotivationKey, string> = {
  taste: 'Taste',
  brandImage: 'Brand image',
  productQuality: 'Product quality',
  price: 'Price',
  productFeatures: 'Product features',
  recommendedByOthers: 'Recommended by other people',
  mentholFlavorExperience: 'Menthol & flavour experience',
};

export function isSetBLdMotivationKey(value: unknown): value is SetBLdMotivationKey {
  return typeof value === 'string' && (SET_B_LD_MOTIVATION_KEYS as readonly string[]).includes(value);
}
